<template>
    <div v-cloak class="row">
        <div class="col-xs-12">
            <div class="box box-primary">
                <div class="box-header with-border">
                    <h3 v-if="type === 1" class="box-title">Actual</h3>
                    <h3 v-else class="box-title">Used</h3>
                    <div class="box-tools pull-right">
                        <button
                            class="btn btn-box-tool"
                            title="Collapse"
                            type="button"
                            @click="collapse = !collapse"
                        >
                            <i :class="[collapse ? 'fa-minus' : 'fa-plus']" class="fa"></i>
                        </button>
                    </div>
                </div>
                <vue-slide-up-down :active="collapse" :duration="durationCollapse">
                    <div v-if="loadingData">
                        <div class="text-center">
                            <img alt="Preloader" class="table-row-preloader" rel="preload" src="/img/table-row-preloader.gif"/>
                        </div>
                    </div>
                    <div v-else class="box-body table-responsive no-padding">
                        <ips-table-component
                            :ips="ipsByType"
                            :ipGroups="ipGroups"
                            :type="type"
                        />
                    </div>
                </vue-slide-up-down>
            </div>
        </div>
    </div>
</template>

<script>
import IpComponent from "./IpComponent";
import IpsTableComponent from "../ip/IpsTableComponent";

export default {
    props: {
        type: Number,
        ips: Array,
        ipGroups: Array
    },
    data() {
        return {
            durationCollapse: 700,
            collapse: this.type === 1,
        }
    },
    computed: {
        ipsByType: function () {
            return this.ips ? this.ips.filter((item) => item.type === this.type) : [];
        },
        loadingData: function () {
            return !this.ips || !this.ipGroups;
        }
    },
    components: {
        IpComponent,
        IpsTableComponent
    }
}
</script>
<style scoped>
.table-responsive {
    overflow: visible;
}
</style>
